
import $ from 'jquery';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { handleError, initClient } from '../../../api';
import { LinkCollection, LinksApiUiClient, ApiException } from '../../backend/backendapi';
import LinkCollectionStore from '../../../stores/LinkCollectionStore';
import CollectionEditor from './CollectionEditor';
import { emptyUUID, WindowType } from '../../../util';
import Spinner from '../../util/Spinner';

declare var window: WindowType;

@Component({
  components: {
    CollectionEditor,
    Spinner,
  },
})
export default class CollectionEditModal extends Vue {
  private readonly api = initClient(LinksApiUiClient);
  private readonly store = new LinkCollectionStore();

  collection: LinkCollection | null = null;
  isNew: boolean = true;
  saving = false;

  public open(collection: LinkCollection, isNew: boolean): void {
    if (isNew) { // fill missing props otherwise reactivity not working
      collection.id ??= emptyUUID();
      collection.accountId ??= window.application.user.fkAccountId ?? -1;
      collection.name ??= '';
      collection.description ??= '';
      collection.links ??= [];
    }
    this.collection = LinkCollection.fromJS(collection); // make copy for editing, otherwise we modify the cached version used elsewhere
    this.isNew = isNew;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  private async save(): Promise<void> {
    if (!this.collection) {
      return;
    }

    this.saving = true;
    try {
      let res: LinkCollection;
      if (this.isNew) {
        res = await this.api.insert(this.collection);
      } else {
        res = await this.api.update(this.collection);
      }

      this.$toasted.info(this.$t('txtSaved').toString());
      this.$emit('saved');
      this.store.updateCollection(res);
      this.isNew = false;
      this.dismiss();
    } catch (e: any) {
      if (ApiException.isApiException(e) && e.status === 400) {
        this.$toasted.info(this.$t('error.badRequest').toString());
      } else {
        handleError(this.$toasted, this.$i18n, e);
      }
    } finally {
      this.saving = false;
    }
  }
}
